(() => {
  'use strict';

  const DEFAULT_API_URL = 'https://script.google.com/macros/s/AKfycbx4o7EeOP02BZVv5AwtiFGY-5uTiGalPiJzqIUu7r9hRPPNdasApH7wGxjNxwVRtrQdcA/exec';
  const modal = document.getElementById('freeCallModal');
  const form = document.getElementById('freeCallForm');
  if (!modal || !form) return;

  const formStep = document.getElementById('freeCallFormStep');
  const successStep = document.getElementById('freeCallSuccess');
  const nameInput = document.getElementById('freeCallName');
  const phoneInput = document.getElementById('freeCallPhone');
  const status = document.getElementById('freeCallStatus');
  const submit = document.getElementById('freeCallSubmit');
  let trigger = null;
  let requestId = '';

  const text = value => String(value || '').replace(/\s+/g, ' ').trim();
  const apiUrl = () => {
    const configured = document.querySelector('[data-booking-api-url]')?.dataset.bookingApiUrl?.trim();
    return configured || window.DoctorBookingConfig?.apiUrl || DEFAULT_API_URL;
  };
  const isFreeCallTrigger = element => {
    if (!element || element.hasAttribute('data-free-call-ignore')) return false;
    const label = text(element.value || element.textContent).toLowerCase();
    return element.matches('[data-free-call], .consult-btn') ||
      (/\bfree\b/.test(label) && /\bcall\b/.test(label)) ||
      /^book (?:your )?15(?:-| )?min(?:ute)?s? call$/.test(label);
  };
  const makeRequestId = () => window.crypto?.randomUUID?.() ||
    `free-call-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  const triggerContext = element => {
    const card = element?.closest('.t-card, .mini-card, .profile-page, #profileContent, [data-therapist-id]');
    return {
      doctorId: text(element?.dataset.docId || element?.dataset.consult || card?.dataset.id || card?.dataset.therapistId),
      doctorName: text(element?.dataset.docName || card?.querySelector('.name-row h2, .mini-name-row h3, [data-bind="name"]')?.textContent),
      buttonLabel: text(element?.value || element?.textContent)
    };
  };

  function setStatus(message, isError) {
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function openModal(element) {
    trigger = element;
    requestId = makeRequestId();
    form.reset();
    setStatus('');
    formStep.hidden = false;
    successStep.hidden = true;
    modal.hidden = false;
    document.documentElement.classList.add('fc-modal-open');
    window.setTimeout(() => nameInput.focus(), 0);
  }

  function closeModal() {
    modal.hidden = true;
    document.documentElement.classList.remove('fc-modal-open');
    trigger?.focus?.();
    trigger = null;
  }

  document.addEventListener('click', event => {
    const candidate = event.target.closest('a, button, input[type="button"], input[type="submit"]');
    if (!isFreeCallTrigger(candidate) || modal.contains(candidate)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openModal(candidate);
  }, true);

  modal.addEventListener('click', event => {
    if (event.target.closest('[data-free-call-close]')) closeModal();
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && !modal.hidden) closeModal();
  });

  form.addEventListener('submit', async event => {
    event.preventDefault();
    const patientName = text(nameInput.value);
    const patientPhone = text(phoneInput.value);
    const digits = patientPhone.replace(/\D/g, '');
    if (patientName.length < 2) {
      setStatus('Please enter your name.', true);
      nameInput.focus();
      return;
    }
    if (digits.length < 10 || digits.length > 15) {
      setStatus('Please enter a valid phone number.', true);
      phoneInput.focus();
      return;
    }

    const originalLabel = submit.textContent;
    submit.disabled = true;
    submit.textContent = 'Booking…';
    setStatus('');
    try {
      const context = triggerContext(trigger);
      const response = await fetch(apiUrl(), {
        method: 'POST',
        credentials: 'omit',
        cache: 'no-store',
        headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
        body: JSON.stringify({
          action: 'free_call',
          request_id: requestId,
          patient_name: patientName,
          patient_phone: patientPhone,
          doctor_id: context.doctorId,
          doctor_name: context.doctorName,
          source_page: window.location.href,
          button_label: context.buttonLabel
        })
      });
      const responseText = await response.text();
      let result = null;
      try { result = JSON.parse(responseText); } catch (_) { }
      if (!response.ok) {
        throw new Error(result?.message || `The booking service returned HTTP ${response.status}.`);
      }
      if (!result) {
        throw new Error('The booking service returned an invalid response.');
      }
      if (result.success !== true) {
        throw new Error(result?.message || 'We could not book your free call. Please try again.');
      }
      formStep.hidden = true;
      successStep.hidden = false;
      successStep.querySelector('button')?.focus();
    } catch (error) {
      console.error('[FreeCall] Booking failed.', error);
      setStatus(error?.message || 'We could not book your free call. Please try again.', true);
    } finally {
      submit.disabled = false;
      submit.textContent = originalLabel;
    }
  });
})();
